import firebaseApp from 'commons/firebase-config'
import { getStorage, ref as fireStorageRef } from 'firebase/storage'

const fireStorage = getStorage(firebaseApp)
export { fireStorage, fireStorageRef }
